export const siviSectionRows = [
  {
    title: 'VEHICLE-IDENTIFICATION-DATA',
    data: [
      [
        {
          key: 'PLATE',
          value: 'targa',
          type: 'string'
        },
        {
          key: 'CHASSIS',
          value: 'idVeicAlt',
          type: 'string'
        },
        {
          key: 'ANIA-VEHICLE-TYPE',
          value: 'tipoVeicoloLabel',
          type: 'string'
        },
        {
          key: 'MCTC-VEHICLE-TYPE',
          value: 'tipoVeicoloMCTCLabel',
          type: 'string'
        }
      ],
      [
        {
          key: 'PREVIOUS-PLATE',
          value: 'targaPrecedente',
          type: 'string'
        },
        {
          key: 'VEHICLE-ORIGIN',
          value: 'provenienza',
          type: 'string'
        },
        {
          key: 'FOREIGN-STATE-OR-SPCL-FORCES',
          value: 'statoEsteroCorpi',
          type: 'string'
        }
      ],
      [
        {
          key: 'MOPED-CIC-CODE',
          value: 'codIdentCiclom',
          type: 'string'
        },
        {
          key: 'START-DATE-MOPED-CIRCULATION',
          value: 'dataInizCircCic',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'REGISTRATION-CERTIFICATE-ISSUING-DATA',
    data: [
      [
        {
          key: 'CARD-ISSUE-DATE',
          value: 'dataEmissione',
          type: 'string'
        },
        {
          key: 'REGISTRATION-DATE',
          value: 'dataImmatricolazione',
          type: 'string'
        },
        {
          key: 'OPERATION-DATE',
          value: 'dataOperazione',
          type: 'string'
        },
        {
          key: 'OPERATION-TIME',
          value: 'oraOperazione',
          type: 'string'
        }
      ],
      [
        {
          key: 'CARD-ISSUING-PROVINCE',
          value: 'provemi',
          type: 'string'
        },
        {
          key: 'MOVEMENT-TYPE',
          value: 'tipoImmatricolazione',
          type: 'string'
        },
        {
          key: 'CAUSE-MCTC',
          value: 'codiceCausale',
          type: 'string'
        },
        {
          key: 'CAUSE-ACI',
          value: 'codiceCausaleACI',
          type: 'string'
        },
        {
          key: 'DATE-PRIMARY-REGISTRATION',
          value: 'annoImmatricolazi',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'VEHICLE-OWNER-DATA',
    data: [
      [
        {
          key: 'FISCAL-CODE',
          value: 'codiceFiscale',
          type: 'string'
        },
        {
          key: 'RESIDENCE-PROVINCE',
          value: 'provres',
          type: 'string'
        },
        {
          key: 'RESIDENCE-MUNICIPALITY',
          value: 'nomeComune',
          type: 'string'
        }
      ],
      [
        {
          key: 'OWNER-DENOMINATION-TYPE',
          value: 'tipoDenominazione',
          type: 'string'
        },
        {
          key: 'ISTAT-RESIDENCE-PROVINCE-CODE',
          value: 'provIstat',
          type: 'string'
        },
        {
          key: 'ISTAT-RESIDENCE-MUNICIP-CODE',
          value: 'comuneIstat',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'TEMPORARY-OWNER-DATA',
    data: [
      [
        {
          key: 'FISCAL-CODE',
          value: 'codiceFiscaleIntestatarioProvv',
          type: 'string'
        },
        {
          key: 'RESIDENCE-PROVINCE',
          value: 'provinciaResidenzaIntestatarioProvv',
          type: 'string'
        },
        {
          key: 'RESIDENCE-MUNICIPALITY',
          value: 'comuneResidenzaIntestatarioProvv',
          type: 'string'
        }
      ],
      [
        {
          key: 'OWNER-DENOMINATION-TYPE',
          value: 'tipoDenomIntestatarioProvv',
          type: 'string'
        },
        {
          key: 'ISTAT-RESIDENCE-PROVINCE-CODE',
          value: 'provinciaResidenzaIntestatarioProvvIstat',
          type: 'string'
        },
        {
          key: 'ISTAT-RESIDENCE-MUNICIP-CODE',
          value: 'comuneResidenzaIntestatarioProvvIstat',
          type: 'string'
        }
      ],
      [
        {
          key: 'OWNER-TYPE',
          value: 'codiceTipoIntestatarioProvv',
          type: 'string'
        },
        {
          key: 'TEMPORARY-OWNING-START-DATE',
          value: 'dataInizioIntestatarioProvv',
          type: 'string'
        },
        {
          key: 'TEMPORARY-OWNING-END-DATE',
          value: 'dataFineIntestatarioProvv',
          type: 'string'
        }
      ]
    ]
  },
  {
    title: 'APPROVAL-DATA',
    data: [
      [
        {
          key: 'APPROVAL-CODE',
          value: 'omologazione',
          type: 'string'
        },
        {
          key: 'APPROVAL-DATE',
          value: 'dtOmologazione',
          type: 'string'
        },
        {
          key: 'APPROVAL-UPDATE-DATE',
          value: 'dataAggOmol',
          type: 'string'
        },
        {
          key: 'APPROVAL-MODIFICATION',
          value: 'modificabilita',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'VEHICLE-TECHNICAL-DATA',
    data: [
      [
        {
          key: 'MANUFACTURER-MODEL',
          value: 'nomeCostr',
          type: 'string'
        },
        {
          key: 'MANUFACTURER-NATIONALITY',
          value: 'nazione',
          type: 'string'
        }
      ],
      [
        {
          key: 'COMMERCIAL-NAME',
          value: 'denomComm',
          type: 'string'
        },
        {
          key: 'VARIANT-MODEL',
          value: 'varianteModello',
          type: 'string'
        },
        {
          key: 'VEHICLE-MODEL-MAKE',
          value: 'marcaModello',
          type: 'string'
        },
        {
          key: 'MODEL-TYPE',
          value: 'tipoModello',
          type: 'string'
        }
      ],
      [
        {
          key: 'MODEL-VERSION',
          value: 'versioneModello',
          type: 'string'
        },
        {
          key: 'USE',
          value: 'use',
          type: 'string'
        },
        {
          key: 'BODYWORK-DESCRIPTION',
          value: 'codCarrozz',
          type: 'string'
        },
        {
          key: 'CATEGORY',
          value: 'category',
          type: 'string'
        }
      ],
      [
        {
          key: 'ENGINE-CAPACITY',
          value: 'cilindrata',
          type: 'string'
        },
        {
          key: 'FISCAL-HORSE-POWER',
          value: 'cavalli',
          type: 'number'
        },
        {
          key: 'KILO-WATT-SHORT',
          value: 'potenza',
          type: 'string'
        },
        {
          key: 'CYLINDER',
          value: 'cilindri',
          type: 'number'
        }
      ],
      [
        {
          key: 'GEAR',
          value: 'marce',
          type: 'number'
        },
        {
          key: 'ACES',
          value: 'assi',
          type: 'number'
        },
        {
          key: 'ENGINE_RPM',
          value: 'girimot',
          type: 'number'
        },
        {
          key: 'MAX-SPEED',
          value: 'velmax',
          type: 'string'
        }
      ],
      [
        {
          key: 'TOTAL-WEIGHT',
          value: 'pesoVeic',
          type: 'number'
        },
        {
          key: 'TOWABLE-WEIGHT',
          value: 'pesoRimor',
          type: 'number'
        },
        {
          key: 'FIFTH-WHEEL-WEIGHT',
          value: 'pesoRalla',
          type: 'number'
        },
        {
          key: 'TARE',
          value: 'pesoTara',
          type: 'number'
        }
      ],
      [
        {
          key: 'POWER-TYPE',
          value: 'codAlimenta',
          type: 'string'
        },
        {
          key: 'LENGTH',
          value: 'lunga',
          type: 'string'
        },
        {
          key: 'WIDTH',
          value: 'larga',
          type: 'string'
        },
        {
          key: 'CATOGORY-INTERNATIONAL-BODY',
          value: 'carattBase',
          type: 'string'
        }
      ],
      [
        {
          key: 'OVERALL-POTENTIAL-WEIGHT',
          value: 'pesoPotCompless',
          type: 'number'
        },
        {
          key: 'POTENTIAL-TOWABLE-WEIGHT',
          value: 'pesoPotRimorch',
          type: 'number'
        },
        {
          key: 'MAX-POTENTIAL-WEIGHT',
          value: 'pesoPotMax',
          type: 'number'
        },
        {
          key: 'TOTAL-NUMBER-SEATS',
          value: 'posti',
          type: 'number'
        }
      ],

      [
        {
          key: 'NUMBER-FRONT-SEATS',
          value: 'numPostiAnt',
          type: 'number'
        },
        {
          key: 'SEATING',
          value: 'postiASedere',
          type: 'number'
        },
        {
          key: 'LEG-ROOM',
          value: 'postiInPiedi',
          type: 'number'
        },
        {
          key: 'SERVICE-POSTS',
          value: 'postiServizio',
          type: 'number'
        }
      ],
      [
        {
          key: 'REAR-OVERHANG',
          value: 'sbalzo',
          type: 'string'
        },
        {
          key: 'BRIDGE-REPORT',
          value: 'rapportoPonte',
          type: 'string'
        },
        {
          key: 'VALIDITY-TYPE',
          value: 'tpValidita',
          type: 'string'
        },
        {
          key: 'BODYWORK-SPECIALIZATION',
          value: 'carrozzeriaSpacializ',
          type: 'string'
        }
      ],
      [
        {
          key: 'FIRST-AXIS-DISTANCE',
          value: 'interasse1',
          type: 'string'
        },
        {
          key: 'SECOND-AXIS-DISTANCE',
          value: 'interasse2',
          type: 'string'
        },
        {
          key: 'THIRD-AXIS-DISTANCE',
          value: 'interasse3',
          type: 'string'
        }
      ],
      [
        {
          key: 'SCOPE',
          value: 'portata',
          type: 'number'
        },
        {
          key: 'USEABLE-RANGE',
          value: 'portataUtile',
          type: 'number'
        },
        {
          key: 'POTENTIAL-RANGE',
          value: 'portataPot',
          type: 'number'
        }
      ],
      [
        {
          key: 'ENGINE-CODE-DESCRIPTION',
          value: 'modMotore',
          type: 'string'
        },
        {
          key: 'NUMBER-OF-TIMES',
          value: 'numTempi',
          type: 'number'
        },
        {
          key: 'MAXIMUM-POWER-TYPE',
          value: 'potenzaMaxTp',
          type: 'string'
        }
      ],
      [
        {
          key: 'TRANSMISSION-REPORT',
          value: 'rappTrasmissione',
          type: 'string'
        },
        {
          key: 'POWER-STEERING',
          value: 'servosterzo',
          type: 'string'
        },
        {
          key: 'DESCRIPTION-TYRES',
          value: 'pneumatici',
          type: 'string'
        }
      ],
      [
        {
          key: 'SERVICE-BRAKE-TYPE',
          value: 'frenoServTp',
          type: 'string'
        },
        {
          key: 'EMERGENCY-BRAKE-TYPE',
          value: 'frenoSoccTp',
          type: 'string'
        },
        {
          key: 'APPROXIMATE-SERVICE-BRAKES',
          value: 'frenoServAppr',
          type: 'string'
        }
      ],
      [
        {
          key: 'DECIBEL-NUMBER',
          value: 'decibelNumEsteso',
          type: 'string'
        },
        {
          key: 'REVOLUTIONS-DECIBEL-NUMBER',
          value: 'decibelGiriMin',
          type: 'number'
        },
        {
          key: 'APPROX-SILENCER',
          value: 'silenziatoreAppr',
          type: 'string'
        }
      ],
      [
        {
          key: 'GEARBOX-TYPE',
          value: 'tpCambio',
          type: 'string'
        },
        {
          key: 'ABS-TYPE',
          value: 'tipoAbs',
          type: 'string'
        },
        {
          key: 'SPEED-LIMITER',
          value: 'limitatVelocita',
          type: 'string'
        }
      ],
      [
        {
          key: 'FIFTH-WHEEL-FROM',
          value: 'rallaDa',
          type: 'number'
        },
        {
          key: 'FIFTH-WHEEL-TO',
          value: 'rallaA',
          type: 'number'
        },
        {
          key: 'TOW-HOOK-APPLICATION',
          value: 'applicGancio',
          type: 'string'
        }
      ],
      [
        {
          key: 'RECALLS-NUMBER-LIMIT',
          value: 'limRichiamoNum',
          type: 'number'
        },
        {
          key: 'RECALLS-YEAR-LIMIT',
          value: 'limRichiamoAa',
          type: 'string'
        },
        {
          key: 'POLLUTION-CLASS',
          value: 'euro',
          type: 'string'
        }
      ],
      [
        {
          key: 'VALUE',
          value: 'valore',
          type: 'string'
        },
        {
          key: 'OFF-ROAD-ID',
          value: 'idFuoristrada',
          type: 'string'
        },
        {
          key: 'NITROGEN-EMISSION',
          value: 'emissBiossido',
          type: 'string'
        }
      ],
      [
        {
          key: 'NITROGEN-EMISSION-INDICATOR',
          value: 'indicatoreEmiAzo',
          type: 'string'
        },
        {
          key: 'CARBON-ENISSION-INDICATOR',
          value: 'indicatoreEmiCar',
          type: 'string'
        },
        {
          key: 'CARBON-EMISSIONS',
          value: 'emissioneCo2',
          type: 'string'
        }
      ],
      [
        {
          key: 'STATISTICAL-DESCRIPTION',
          value: 'righeDescr',
          type: 'string'
        }
      ]
    ]
  }
];

export const sitaBusinessDetailsRows = [
  {
    title: '',
    data: [
      [
        {
          key: 'BUSINESS',
          value: 'impresaDb',
          type: 'string'
        },
        {
          key: 'STATE',
          value: 'activity',
          type: 'string'
        }
      ]
    ]
  }
];

export const sitaCoverageDetailsRows = [
  {
    title: '',
    data: [
      [
        {
          key: 'PLATE',
          value: 'targa',
          type: 'string'
        },
        {
          key: 'VEHICLE-TYPE',
          value: 'tipoVeicolo',
          type: 'string'
        },
        {
          key: 'MCTC-VEHICLE-TYPE',
          value: 'tipoVeicoloMCTC',
          type: 'string'
        },
        {
          key: 'IUR-CODE',
          value: 'codiceIUR',
          type: 'string'
        }
      ],
      [
        {
          key: 'COVERAGE-START-DATE',
          value: 'effettoCopertura',
          type: 'string'
        },
        {
          key: 'COVERAGE-START-TIME',
          value: 'oraEffCop',
          type: 'string'
        },
        {
          key: 'DATE-END-COVERAGE',
          value: 'scadenzaCopertura',
          type: 'string'
        },
        {
          key: 'TIME-END-COVERAGE',
          value: 'oraScadCop',
          type: 'string'
        }
      ],
      [
        {
          key: 'DUE-START-DATE',
          value: 'dataScadMora',
          type: 'string'
        },
        {
          key: 'COVERAGE-EXTENSION-DAYS',
          value: 'ggesteCop',
          type: 'string'
        },
        {
          key: 'COVERAGE-COLLECTION-DATE',
          value: 'dataIncasso',
          type: 'string'
        },
        {
          key: 'PAYMENT-MODE',
          value: 'modPagam',
          type: 'string'
        }
      ],
      [
        {
          key: 'POLICY-NUMBER',
          value: 'numPolizza',
          type: 'string'
        },
        {
          key: 'POLICY-START-DATE',
          value: 'effettoPolizza',
          type: 'string'
        },
        {
          key: 'POLICY-END-DATE',
          value: 'scadenzaPolizza',
          type: 'string'
        },
        {
          key: 'SUSPENSTION-START-DATE',
          value: 'dataScadenzaSospensione',
          type: 'string'
        }
      ],
      [
        {
          key: 'RATE',
          value: 'tariffa',
          type: 'string'
        },
        {
          key: 'POLICY-TYPE',
          value: 'tipoPolizza',
          type: 'string'
        },
        {
          key: 'BLACK-BOX',
          value: 'blackBox',
          type: 'string'
        }
      ],
      [
        {
          key: 'CONTRACTOR-FISCAL-CODE',
          value: 'idFiscContraente',
          type: 'string'
        },
        {
          key: 'OWNER-FISCAL-CODE',
          value: 'idFiscProprietar',
          type: 'string'
        },
        {
          key: 'CAUSE',
          value: 'tipoMov',
          type: 'string'
        },
        {
          key: 'COMPLETION-DATE',
          value: 'datiCompleti',
          type: 'string'
        }
      ],

      [
        {
          key: 'SITA-UPDATE-DATE',
          value: 'dataLastAgg',
          type: 'string'
        },
        {
          key: 'SITA-UPDATE-TIME',
          value: 'timeLastAgg',
          type: 'string'
        },
        {
          key: 'UPDATE-CHANNEL',
          value: 'canaleAgg',
          type: 'string'
        }
      ]
    ]
  }
];

export const atrcSectionRows = [
  {
    title: 'INSURANCE-COMPANY',
    titleValue: 'codImpCTPLabel',
    data: [
      [
        {
          key: 'VEHICLE-TYPE',
          value: 'tipoVeicoloLabel',
          type: 'string'
        },
        {
          key: 'PLATE',
          value: 'targa',
          type: 'string'
        },
        {
          key: 'IUR-CODE',
          value: 'codiceIUR',
          type: 'string'
        },
        {
          key: 'POLICY-NUMBER',
          value: 'numPolizza',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'CONTRACTOR',
    data: [
      [
        {
          key: 'SURNAME-BUSINESSNAME',
          value: 'cognomeRagSocContr',
          type: 'string'
        },
        {
          key: 'NAME',
          value: 'nomeContr',
          type: 'string'
        },
        {
          key: 'TAX-ID',
          value: 'codiceFiscaleContr',
          type: 'string'
        }
      ]
    ]
  },

  {
    title: 'ELIGIBILITY',
    data: [
      [
        {
          key: 'SURNAME-BUSINESSNAME',
          value: 'cognomeRagSocAventeDiritto',
          type: 'string'
        },
        {
          key: 'NAME',
          value: 'nomeAventeDiritto',
          type: 'string'
        },
        {
          key: 'TAX-ID',
          value: 'codiceFiscaleAventeDiritto',
          type: 'string'
        }
      ]
    ]
  },
  {
    title: '',
    data: [
      [
        {
          key: 'CONTRACTUAL-EXPIRY',
          value: 'dataScadContratto',
          type: 'string'
        },
        {
          key: 'TARRIF-FORM',
          value: 'tariffa',
          type: 'string'
        },
        {
          key: 'APPLICATION-BERSANI-LAW',
          value: 'codLegge',
          type: 'string'
        },
        {
          key: 'UNPAID-DEDUCTIBLES',
          compositeValue: true,
          value: [
            {
              key: 'DEDUCTIBLES-NUM',
              value: 'numFranNocorr',
              type: 'number'
            },
            {
              key: 'DEDUCTIBLES-IMPORT',
              value: 'impFranNocorr',
              type: 'number'
            }
          ]
        }
      ],
      [
        {
          key: 'COMPANY-ORIGIN-CLASS',
          value: 'classeImprDa',
          type: 'string'
        },
        {
          key: 'COMPANY-CLASS-ASSIGNMENT',
          value: 'classeImprA',
          type: 'string'
        },
        {
          key: 'CU-ORIGIN-CLASS',
          value: 'classeCuDa',
          type: 'string'
        },
        {
          key: 'CU-CLASS-ASSIGNMENT',
          value: 'classeCuA',
          type: 'string'
        }
      ],
      [
        {
          key: 'DATA-ENTERED-IN-DB',
          value: 'timestampIns',
          type: 'string'
        },
        {
          key: 'INSERTION-FLOW-DATE',
          value: 'dataFlussoIns',
          type: 'string'
        },
        {
          key: 'INSERT-MOVEMENT-TYPE',
          value: 'tipoMovIns',
          type: 'string'
        },
        {
          key: 'INSERT-REASON',
          value: 'causMovIns',
          type: 'string'
        }
      ],
      [
        {
          key: 'UPDATE-DATA-IN-DB',
          value: 'timestampAgg',
          type: 'string'
        },
        {
          key: 'UPDATE-DATE',
          value: 'dataFlussoAgg',
          type: 'string'
        },
        {
          key: 'UPDATE-MOVEMENT-TYPE',
          value: 'tipoMovAgg',
          type: 'string'
        },
        {
          key: 'UPDATE-REASON',
          value: 'causMovAgg',
          type: 'string'
        }
      ]
    ]
  }
];

export const siviSectionSummary = {
  data: [
    {
      key: 'VEHICLE-TYPE',
      value: 'tipoVeicoloLabel',
      type: 'string'
    },
    {
      key: 'BRAND',
      value: 'marcaModello',
      type: 'string'
    },
    {
      key: 'MODEL',
      value: 'denomComm',
      type: 'string'
    },
    {
      key: 'ENGINE-CAPACITY',
      value: 'cilindrata',
      type: 'string'
    },
    {
      key: 'POWER-SUPPLY',
      value: 'codAlimenta',
      type: 'string'
    },
    {
      key: 'DATE-PRIMARY-REGISTRATION',
      value: 'dataImmatricolazione',
      type: 'string'
    },
    {
      key: 'FISCAL-CODE',
      value: 'codiceFiscale',
      type: 'string'
    }
  ]
};

export const sitaSectionSummary = {
  data: [
    {
      key: 'NO-COMPAINES-COVERED',
      value: 'numCompCopertura',
      type: 'string'
    },
    {
      key: 'FINAL-COVERAGE',
      value: ''
    },
    {
      key: 'COMPANY',
      value: 'impresaDbLabel',
      type: 'string'
    },
    {
      key: 'COVERAGE-EFFECT-DATE',
      // value: 'dataEffettoCopertura',
      compositeValue: true,
      separator: ' - ',
      value: [
        {
          value: 'effettoCopertura',
          type: 'string'
        },
        {
          value: 'oraEffCop',
          type: 'string'
        }
      ]
    },
    {
      key: 'COVERAGE-EXPIRE-DATE',
      // value: 'dataScadenzaCopertura',
      compositeValue: true,
      separator: ' - ',
      value: [
        {
          value: 'scadenzaCopertura',
          type: 'string'
        },
        {
          value: 'oraScadCop',
          type: 'string'
        }
      ]
      //type: 'string'
    },

    {
      key: 'POLICY-NUMBER',
      value: 'numPolizza',
      type: 'string'
    },
    {
      key: 'POLICY-EFFECT-DATE',
      // value: 'dataEffettoPolizza',
      value: 'effettoPolizza', //for api gateway
      type: 'string'
    },
    {
      key: 'POLICY-EXPIRE-DATE',
      // value: 'dataScadenzaPolizza',
      value: 'scadenzaPolizza', // for api gateway
      type: 'string'
    }
  ]
};

export const atrcSectionSummary = {
  data: [
    {
      key: 'BUSINESS',
      value: 'codImpCTPLabel',
      type: 'string'
    },
    {
      key: 'NAME-SURNAME',
      compositeValue: true,
      separator: ' ',
      value: [
        {
          value: 'cognomeRagSocContr',
          type: 'string'
        },
        {
          value: 'nomeContr',
          type: 'string'
        }
      ]
    },
    {
      key: 'END-ATRC',
      value: 'dataScadContratto',
      type: 'string'
    },
    {
      key: 'CU-ORIGIN-CLASS',
      // value: 'classeCuDa',
      value: 'classeCuDa', //for api gateway
      type: 'string'
    },
    {
      key: 'CU-CLASS-ASSIGNMENT',
      // value: 'classeCuA',
      value: 'classeCuA', // for api gateway
      type: 'string'
    },

    {
      key: 'THIRD-PARTY-LIABILITY-CLAIMS-IN-5-YEARS',
      value: 'numSinistriRC5Anni', // not available in api gateway response
      type: 'number'
    },
    {
      key: 'THIRD-PARTY-LIABILITY-CLAIMS-IN-2-YEARS',
      value: 'numSinistriRC2Anni', // not available in api gateway response
      type: 'number'
    }
  ]
};


